import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';

import { Typography,
         Button,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight,
         faTimes } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons

import { CONSTS, INFO,
         TIMES, } from '../util/object';
import { showLoadingMessage, 
         adjustDisplayDiv,
         setFrameEvent,
         processTutorialText,
        } from '../util/util';
import { GATag, Stack } from "../util/tools";
import { appContext } from "./index";
import { GoBack,
         Wait } from "./Util";
import { initVideoDisplay} from '../util/annotate'
import { UTIL_useStyles } from "../components/Util";


const auth_useStyles = makeStyles(theme => ({
    tutorial_root: {    // use absolute position to float atop
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        padding: "0",
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '600',      // MUST BE ON TOP!  below the wait spinner (500)   was: 250
        backgroundColor: '#7b7e9a9c',
    },
    display_container: {        // use this to create the dialog shape
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        position: 'relative',
        display: "flex",
        padding: '20px 0',
        width: "80%",
        height: "80%", 
        maxHeight: '300px',
        maxWidth: '400px',
        margin: '10vh auto',
        alignItems: "flex-start",
        justifySelf: 'center',

        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '12px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 5px 10px -3px',
        backgroundColor: '#52567cf8',
        overflow: 'auto',
    },

    next_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
            borderColor: 'rgba(255,255,255,0)',
        },
		fontSize: '1.2rem',
        height: '8vh',
        width: '20vh',
        minWidth: '180px',
        minHeight: '60px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0.5vh',
        padding: '10px',
        backgroundColor: 'rgba(53, 86, 102, 0.95)', 
        color: 'white',
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        //boxShadow: '0 10 20 0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    catalog_theme: {
        backgroundColor: 'rgba(79,119, 137, 1)',
    },
    dismiss_icon: {
        position: 'absolute',
        right: "5px",
        top: "5px",
        color:'#eaeaf5',
        alignSelf: "center",
        margin: '0px',
        marginLeft: '8px',
        padding: '0px',
        //marginLeft: '5vw',
        minWidth: '20px',
        width: '40px',
    },
    video_container: {
        //display: "none",
        display: "flex",
        padding: '0',
        margin: '0',
        width: "auto",
        height: "auto",
        flexDirection: "row",
        //alignItems: "flex-start",
        justifySelf: "flex-start",
        alignSelf: "center",        // in case not covering 100%
        background: '#6f6f74',
    },

    tut_vid_container: {
        display: "flex",
        flexDirection: "column",
        justifySelf: "flex-start",
        padding: '0',
        margin: '0',
        //paddingBottom: "56.25%",
        //paddingTop: "50px",
        height: "auto",
        width: "auto",
        background: '#6f6f74',
    },
    tut_text_container: {
        display: "flex",
        height: "auto",
        width: "auto",
        flexDirection: "column",
        justifySelf: "flex-start",
        padding: '5% 8%',
        overflow: 'auto',
    },
    tut_text: {
        margin: '0',
        padding: '0',
        marginBottom: '16px',
        //marginTop: CONSTS.GOBACK_BAR_HEIGHT,
		fontSize: '1.1rem',
        lineHeight: '1.6rem',
        alignSelf: 'center',
        color: '#dee3f1',
        //background: '#6f6f74',
    },
    tut_vid_iframe: {
        margin: '0',
        padding: '0',
        //width: '100vw',
        //height: '100vh',
    },


}));



// Display tutorial video on any screen
const Tutorial = (props) => {
    const classes = auth_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }

    const [ ButtonText, setButtonText ] = useState(true);
    const [ TutorialRedirect, setTutorialRedirect ] = useState(false);
    const [ TutorialTarget, setTutorialTarget ] = useState("");
    const [ VidWidth, setVidWidth ] = useState("");
    const [ VidHeight, setVidHeight ] = useState("");
    const [ PlayURL, setPlayURL ] = useState(null);
    const [ Texts, setTexts ] = useState([]);
    const [ Title, setTitle ] = useState(null);
    const [ Refresh, setRefresh ] = useState(0);

    useEffect(() => {
        if(INFO.show_tutorial === false) {
            return;
        }

		var output = document.getElementById('tut_output');
        console.log("Tutorial.191: ######### Start TUTORIALS Mode..... show=",props.Show);

        var show = props.Show;
        setTitle("ABOUT " + show.name);

        var texts = processTutorialText(show.text);
        setTexts(texts);

        if(show.url !== undefined) {
            setPlayURL(show.url);
            output.setAttribute("width", show.width);
            output.setAttribute("height", show.height);
        }

        INFO.tutorial_mode = true;

        setButtonText("NEXT");
        GATag("Tutorial", "Tutorial.Entry", "", 0);		 // (cat, act, lab, val)

        adjustDisplayDiv("tut_init.210");
        window.addEventListener('resize', adjustDisplayDiv);
        window.addEventListener("orientationchange", adjustDisplayDiv);

        return function cleanup() {
            console.log("Tutorial.215:   CLEANUP TUTORIALS Mode.....");
            window.removeEventListener('resize', adjustDisplayDiv);
            window.removeEventListener("orientationchange", adjustDisplayDiv);
        };

    }, [1]);

    useEffect(() => {
        console.log("Tutorial.223:   Display Refresh ", Refresh);
        adjustDisplayDiv("tut_refresh.224");
    }, [Refresh, TutorialRedirect]);


    // unset the mode and dismiss it
    const handleDismiss = () => {
        console.log("tut.176: ----->  REACHED HANDLE_DISMISS");
        INFO.tutorial_mode = false;
        props.Dismiss();
    }


                                //width={VidWidth} height={VidHeight}
                    //<GoBack ZIndex={50} Title={Title} GoBack={props.Dismiss} Icon={faTimes} />
                    //<GoBack ZIndex={props.ZIndex} Title={Title} Color="#3f2ee3e6" GoBack={handleDismiss} Icon={faTimes} />

    return (
        <React.Fragment>
            {INFO.show_tutorial && 
            <Container id="tutorial_root" className={classes.tutorial_root}>
                <Container id="display_container" className={classes.display_container}>
                    <Button id="back_btn" className={classes.dismiss_icon} onClick={handleDismiss}>
                        <FontAwesomeIcon 
                            icon={faTimes}
                            style={{ fontSize: "1.5rem"}} />
                    </Button>

                    {(PlayURL === true) ?
                        <Container id="tut_video_container" className={classes.tut_vid_container}>
                            <iframe id="tut_output"
                                    className={classes.tut_vid_iframe}
                                    src={PlayURL}
                                    frameBorder="0" 
                                    allowFullScreen>
                            </iframe>
                        </Container>
                    :
                        <Container id="tut_video_text" className={classes.tut_text_container}>
                            {Texts && Texts.map((text, index) => (
                                <React.Fragment key={"txt0_"+index}>
                                    <p key={"txt1_"+index} className={classes.tut_text}> {text} </p>
                                </React.Fragment>
                            ))}
                        </Container>
                    }

                    {/*<Button id="next_btn" className={classes.next_button} onClick={props.Dismiss}>
                        NEXT
                    </Button>*/}
                </Container>

            </Container>
            }
        </React.Fragment>
    )
}

export default withRouter(Tutorial)